import { Component } from '@angular/core';

@Component({
    selector: 'app-error-layout',
    styles: [],
    templateUrl: './error-layout.component.html'
})
export class ErrorLayoutComponent {

}